import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { DataFetcherHookResult } from '@ts-core/core/types';

import { Student } from '../types';
import { getStudentByIdQuery, GetStudentByIdQueryVariables, GetStudentByIdQueryResult } from '../graphql/queries/getStudentByIdQuery';

interface StudentHookInput {
  courseId: string;
  studentId: string;
}

type StudentHookResult = DataFetcherHookResult<Student, 'student'>;

export default function useStudent(input: StudentHookInput): StudentHookResult {
  const { courseId, studentId } = input;
  const { data, loading, error } = useQuery<GetStudentByIdQueryResult, GetStudentByIdQueryVariables>(getStudentByIdQuery, {
    variables: { courseId, studentId },
  });
  return {
    loading,
    student: data?.student,
    error: getErrorMessage({ error }),
  };
}
